import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { Period } from '@/lib/timePeriod';
import type { SeverityTrendResponse } from '@/types/fraudHub';

/**
 * Fetches the per-severity daily-trend used by the Hub stacked-bar
 * chart. Backend anchors on `max(alert_time)` so the window stays
 * meaningful even when the warehouse lags wall-clock by days.
 *
 * Period-aware (PR 3): window length follows the selected period rather
 * than a hardcoded 30 days. Backend response carries `period_label`
 * which the chart renders in its title.
 */
export function useFraudHubSeverityTrend(
  period: Period,
): UseQueryResult<SeverityTrendResponse, Error> {
  return useQuery<SeverityTrendResponse, Error>({
    queryKey: ['fraud-hub', 'severity-trend', period],
    queryFn: async () => {
      const { data } = await api.get<SeverityTrendResponse>(
        '/fraud-hub/severity-trend',
        { params: { period } },
      );
      return data;
    },
    staleTime: 30_000,
  });
}
